import React, { useState } from "react";
import axios from "axios";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Spinner,
    ButtonGroup,
} from "reactstrap";
import FinancialTransactionForm from "./FinancialTransactionForm";
import MonthlyRecord from "./MonthlyLedger";
import BankTransactionForm from "./BankTransaction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiURL1 } from "../../config";

const MonthlyAccounts = () => {
    const [activeTab, setActiveTab] = useState("addTransaction");

    const [ftOpenModal, setFtOpenModal] = useState(false);
    const [ftDate, setFtDate] = useState(new Date());
    const [ftFromType, setFtFromType] = useState("");
    const [ftToType, setFtToType] = useState("");
    const [ftAmount, setFtAmount] = useState("");
    const [ftRemark, setFtRemark] = useState("");
    const [ftLoading, setFtLoading] = useState(false);

    const openFundTransferModal = () => {
        setFtDate(new Date());
        setFtFromType("");
        setFtToType("");
        setFtAmount("");
        setFtRemark("");
        setFtOpenModal(true);
    };

    const closeFundTransferModal = () => setFtOpenModal(false);

    const saveFundTransfer = async () => {
        if (!ftFromType || !ftToType) return;
        if (ftFromType === ftToType) return;
        if (!ftAmount || Number(ftAmount) <= 0) return;
        try {
            setFtLoading(true);
            const token = localStorage.getItem("token");
            const payload = {
                date: ftDate.toISOString(),
                fromType: ftFromType,
                toType: ftToType,
                amount: Number(ftAmount),
                remark: ftRemark,
            };
            await axios.post(`${apiURL1}/superadmin/fund-transfer`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setFtOpenModal(false);
        } catch (e) {
            console.error(e);
        } finally {
            setFtLoading(false);
        }
    };

    return (
        <Container>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <h3 className="mb-0">Monthly Accounts</h3>
                            <div className="d-flex justify-content-around">
                                <Button
                                    color={activeTab === "addTransaction" ? "primary" : "secondary"}
                                    onClick={() => setActiveTab("addTransaction")}
                                >
                                    Cash Transaction
                                </Button>
                                <Button
                                    color={activeTab === "bankTransaction" ? "primary" : "secondary"}
                                    onClick={() => setActiveTab("bankTransaction")}
                                >
                                    Bank Transaction
                                </Button>
                                <Button
                                    color={"secondary"}
                                    onClick={openFundTransferModal}
                                >
                                    Fund Transfer
                                </Button>
                                <Button
                                    color={activeTab === "monthlyLedger" ? "primary" : "secondary"}
                                    onClick={() => setActiveTab("monthlyLedger")}
                                >
                                    Monthly Ledger
                                </Button>


                            </div>
                        </CardHeader>
                        <CardBody>
                            {activeTab === "addTransaction" && <FinancialTransactionForm />}
                            {activeTab === "monthlyLedger" && <MonthlyRecord />}
                            {activeTab === "bankTransaction" && <BankTransactionForm />}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal isOpen={ftOpenModal} toggle={closeFundTransferModal} centered size="md">
                <ModalHeader toggle={closeFundTransferModal}>Fund Transfer</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Date</Label>
                            <DatePicker
                                selected={ftDate}
                                onChange={(d) => setFtDate(d)}
                                className="form-control"
                                dateFormat="yyyy-MM-dd"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>From</Label>
                            <Input type="select" value={ftFromType} onChange={(e) => setFtFromType(e.target.value)}>
                                <option value="">Select</option>
                                <option value="cash">Cash</option>
                                <option value="bank">Bank</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>To</Label>
                            <Input type="select" value={ftToType} onChange={(e) => setFtToType(e.target.value)}>
                                <option value="">Select</option>
                                <option value="cash">Cash</option>
                                <option value="bank">Bank</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Amount</Label>
                            <Input type="number" min="1" value={ftAmount} onChange={(e) => setFtAmount(e.target.value)} />
                        </FormGroup>
                        <FormGroup>
                            <Label>Remark</Label>
                            <Input type="textarea" rows="3" value={ftRemark} onChange={(e) => setFtRemark(e.target.value)} />
                        </FormGroup>
                        <ButtonGroup size="sm">
                            <Button color="primary" onClick={saveFundTransfer} disabled={ftLoading}>
                                {ftLoading ? <Spinner size="sm" /> : 'Save'}
                            </Button>
                            <Button color="secondary" onClick={closeFundTransferModal}>Cancel</Button>
                        </ButtonGroup>
                    </Form>
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default MonthlyAccounts;
